export const localProductData = {
  id: 1111,
  product_id: "prod_kJOPwNfeGTOYpu9yGEoPibyl",
  marketplace: "WeStore Api",
  marketplace_id: "",
  marketplace_product_id: "",
  name: "Matress Topper 200x200",
  sku: "MT0105",
  price: "50.2",
  inventory_quantity: 1,
  booked_quantity: 0,
  physical_quantity: 0,
  physical_volume: 0,
  blocked_quantity: 0,
  status: "In Stock",
  category: null,
  vendor: null,
  quantity_summary: 1,
  orders_total: 27,
  order_returns_total: 4,
  transactions: [
    {
      id: "ord_Ofw5p8rXbgVBucym8YWlhdZd",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840280,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_Ofw5p8rXbgVBucym8YWlhdZd",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_OoUENZkWGSQmYi2jF51WtTA5",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840458,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_OoUENZkWGSQmYi2jF51WtTA5",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_E1zXcxsrVP4sEcpzbZSC2AVj",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840502,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_E1zXcxsrVP4sEcpzbZSC2AVj",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_QkxMJ1tgRgbxkDeporOg7fyp",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840521,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_QkxMJ1tgRgbxkDeporOg7fyp",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_OaMBADroHKCIpYsfcteJUCfs",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840541,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_OaMBADroHKCIpYsfcteJUCfs",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_GQeOuXkBbKYOirEK1gdWoILq",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840636,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_GQeOuXkBbKYOirEK1gdWoILq",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_c2hAglMGLV78W9ta0brwWxPn",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840691,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_c2hAglMGLV78W9ta0brwWxPn",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_ukWKy3d3OupYa1m7BTsaST1b",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840753,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_ukWKy3d3OupYa1m7BTsaST1b",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_uKKtrGvGqNlZHnw3ZXE79o17",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840816,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_uKKtrGvGqNlZHnw3ZXE79o17",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_2IGhiKMtIdtOdrwsOdmPXMBU",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658840954,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_2IGhiKMtIdtOdrwsOdmPXMBU",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_2JV4MI4uWW2aoHmONuhvgsKh",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658841069,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_2JV4MI4uWW2aoHmONuhvgsKh",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_RGAegTy3nDXMy6zbcl9huw7R",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658841474,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_RGAegTy3nDXMy6zbcl9huw7R",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_YxllGmoFDyiszf8FSpn2bL6f",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658841481,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_YxllGmoFDyiszf8FSpn2bL6f",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_gMvYUE0oDXKLYYderJbBQLFR",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658841745,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_gMvYUE0oDXKLYYderJbBQLFR",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_qWQAgkVmDcP5AgW2CR3p4oH2",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658841762,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_qWQAgkVmDcP5AgW2CR3p4oH2",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_FfYFEdK1trJQb7xlKBEzn1t7",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658841811,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_FfYFEdK1trJQb7xlKBEzn1t7",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_H1yjUuXCeLapVTKf7Z6aoFL8",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658908252,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_H1yjUuXCeLapVTKf7Z6aoFL8",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_oqWqDI5nwFP5Zw6ZQbEGV9in",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658908261,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_oqWqDI5nwFP5Zw6ZQbEGV9in",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_wwNIFX5QRLytTLFj8DRg5gZd",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658908291,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_wwNIFX5QRLytTLFj8DRg5gZd",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_PYlBqJCClsIDr0Z13dsT89yI",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658908890,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_PYlBqJCClsIDr0Z13dsT89yI",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_GRuqpWZ4VAjsvG8K4HivNWA0",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658908950,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_GRuqpWZ4VAjsvG8K4HivNWA0",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_wc60uftwRW1iazsnxofHqTeq",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658910348,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_wc60uftwRW1iazsnxofHqTeq",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_8Jq0XVywTdEW5f91paYVIRfr",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658910356,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_8Jq0XVywTdEW5f91paYVIRfr",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "orret_0bStP7xNnCQwxqRjaltYGtYX",
      quantity: 1,
      type: "Return",
      created: 1658910424,
      pivot: {
        product_variant_id: "2528",
        order_return_id: "orret_0bStP7xNnCQwxqRjaltYGtYX",
        quantity: 1,
      },
    },
    {
      id: "orret_mAPPJAUEQQZGNmKSHpUJdiwz",
      quantity: 1,
      type: "Return",
      created: 1658913718,
      pivot: {
        product_variant_id: "2528",
        order_return_id: "orret_mAPPJAUEQQZGNmKSHpUJdiwz",
        quantity: 1,
      },
    },
    {
      id: "ord_YkloM4rqUryenjOzeNNuGuyd",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658913731,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_YkloM4rqUryenjOzeNNuGuyd",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_MXagtzwwjYVjR7eQ6hqytzDb",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658913832,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_MXagtzwwjYVjR7eQ6hqytzDb",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "orret_r6Rbr15VynJsdrHD35enx20z",
      quantity: 1,
      type: "Return",
      created: 1658922378,
      pivot: {
        product_variant_id: "2528",
        order_return_id: "orret_r6Rbr15VynJsdrHD35enx20z",
        quantity: 1,
      },
    },
    {
      id: "orret_CBQF7yJCBFyBwU9edwdco23n",
      quantity: 1,
      type: "Return",
      created: 1658927295,
      pivot: {
        product_variant_id: "2528",
        order_return_id: "orret_CBQF7yJCBFyBwU9edwdco23n",
        quantity: 1,
      },
    },
    {
      id: "ord_QTH9fhDi5PyR9FsUcNIQNdyX",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1658998255,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_QTH9fhDi5PyR9FsUcNIQNdyX",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: "ord_oBtSBbPQogg52RiLAD67VVMn",
      quantity: 1,
      price: "50.2",
      type: "Order",
      created: 1659278641,
      pivot: {
        product_variant_id: 2528,
        order_id: "ord_oBtSBbPQogg52RiLAD67VVMn",
        quantity: 1,
        price: "50.2",
      },
    },
    {
      id: 1,
      received_quantity: 1000,
      inbound_shipment_id: "insh_cGPLryUHpeMdv6S8DWvdz2YL",
      expected_quantity: 2000,
      type: "Inbound",
      created: 1659948304,
    },
  ],
  created: 1658840280,
};
